import { BuildMetricsTimeSeries } from '@trace/types';

const getCombinedData = (dataOverTime: BuildMetricsTimeSeries[]): BuildMetricsTimeSeries | null => {
  if (dataOverTime.length === 0) {
    return null;
  }

  return dataOverTime.slice(1).reduce((acc, data) => {
    for (let i = 0; i < data.maxTimeAbortManual.length; i += 1) {
      acc.maxTimeAbortManual[i] = Math.max(
        acc.maxTimeAbortManual[i] || 0,
        data.maxTimeAbortManual[i],
      );
      acc.maxTimeAbortRolling[i] = Math.max(
        acc.maxTimeAbortRolling[i] || 0,
        data.maxTimeAbortRolling[i],
      );
      acc.maxTimeFail[i] = Math.max(acc.maxTimeFail[i] || 0, data.maxTimeFail[i]);
      acc.maxTimeSuccess[i] = Math.max(acc.maxTimeSuccess[i] || 0, data.maxTimeSuccess[i]);
      acc.maxTimeWait[i] = Math.max(acc.maxTimeWait[i] || 0, data.maxTimeWait[i]);
      acc.totalBuilds[i] += data.totalBuilds[i];
      acc.totalBuildsAbortedManual[i] += data.totalBuildsAbortedManual[i];
      acc.totalBuildsAbortedRolling[i] += data.totalBuildsAbortedRolling[i];
      acc.totalBuildsFailed[i] += data.totalBuildsFailed[i];
      acc.totalBuildsSuccess[i] += data.totalBuildsSuccess[i];
      acc.totalTime[i] += data.totalTime[i];
      acc.totalTimeAbortManual[i] += data.totalTimeAbortManual[i];
      acc.totalTimeAbortRolling[i] += data.totalTimeAbortRolling[i];
      acc.totalTimeFail[i] += data.totalTimeFail[i];
      acc.totalTimeSuccess[i] += data.totalTimeSuccess[i];
      acc.totalTimeWait[i] += data.totalTimeWait[i];
    }

    return acc;
  }, dataOverTime[0]);
};

export default getCombinedData;
